import { createAsyncThunk } from '@reduxjs/toolkit';

const clearWorkspace = createAsyncThunk(
  'workspaces/clearWorkspace',
  async (): Promise<void> => {
    localStorage.removeItem('selectedWorkspaceId');
  }
);

export default clearWorkspace;
